import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class SelectRemoteWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            optionsSelect: props.options.enumOptions
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            optionsSelect: nextProps.options.enumOptions
        });
    }

    render() {
        console.log('this.props', this.props);
        return (
            <div>
                <Select
                    placeholder={this.props.schema.title}
                    name="singleSelect"
                    value={this.props.value}
                    options={this.state.optionsSelect}
                    required={this.props.required}
                    onChange={event =>
                        event != null
                            ? this.props.onChange(event.value)
                            : this.props.onChange(undefined)
                    }
                />
            </div>
        );
    }
}

export default SelectRemoteWidget;



// WEBPACK FOOTER //
// ./src/lib/widget-select.js